module.exports = __webpack_public_path__ + "static/img/model-bgi.8cfca72a.png";